import { c as _c } from "react/compiler-runtime";
import { IcoCheckSmall24, IcoCloseSmall24 } from '@onefootprint/icons';
type ItemProps = {
  label: string;
  value: React.ReactNode | boolean | string;
};
const Item = t0 => {
  const $ = _c(13);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <div className="text-body-2 text-tertiary">{label}</div>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = typeof value === "boolean" ? <div>{value ? <IcoCheckSmall24 /> : <IcoCloseSmall24 />}</div> : null;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== value) {
    t3 = typeof value === "string" ? <div className="text-body-2 text-primary">{value}</div> : null;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== value) {
    t4 = typeof value === "object" ? <div className="min-w-0">{value}</div> : null;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <li className="flex items-center justify-between gap-6">{t1}{t2}{t3}{t4}</li>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default Item;